import {Component,
    OnInit,
    ElementRef,
    ViewChildren,
    ViewChild,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Inject,
	ViewRef,
	HostListener,
	Optional
}
from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import 'jspdf-autotable';
// Material
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatTabChangeEvent, MatTabGroup, MatTab, MatTabHeader} from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { FormGroup, FormBuilder, Validators} from '@angular/forms';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
// RXJS
import { ReplaySubject,BehaviorSubject } from 'rxjs';
//Service
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, MessageType } from '../../../../../../core/_base/crud';
import { TokenStorage } from '../../../../../../core/auth/_services/token-storage.service';
import { DungChungService } from '../../../dung-chung/__services/dung-chung.service';
import { NhapKhoPageService } from '../kho-nhap-kho-page-service/kho-nhap-kho-page.service';
import { JsPDFFontService } from '../../../dung-chung/__services/pdf-custom-font.service';
import { SoDoKhoService } from '../../../chuc-nang-kho/so-do-kho/so-do-kho-service/so-do-kho.service';

//Model
import { CommonConFig } from 'app/views/pages/nfc/dung-chung/__model/common_config.model';
import { FunctionPublic } from '../../../dung-chung/__function/common_function';
import { DeNghiNhapKhoChiTiet } from '../../kho-phieu-thong-tin-hang-ve-page/phieu-thong-tin-hang-ve-model-page/phieu-thong-tin-hang-ve.model';
import { ChiTietPhieuNhapKho, PhieuNhapKho, NguoiThucHienNhapKho } from '../kho-nhap-kho-page-model/kho-nhap-kho-page.model';
//Component
import { TimKiemNangCaoListComponent } from '../../../../tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { SoDoKhoViewVer2Component } from '../../../chuc-nang-kho/so-do-kho/so-do-kho-view-dialog-ver2/so-do-kho-view-dialog-ver2.component';
import { ThongTinHangVeListDialogComponent } from '../kho-thong-tin-hang-ve-list-dialog/kho-thong-tin-hang-ve-list-dialog.component';
import { DNNKListDialogComponent } from '../kho-de-nghi-nhap-kho-list-dialog/kho-de-nghi-nhap-kho-list-dialog.component';
import { KhoNhapPageFileComponent } from '../kho-nhap-page-file/kho-nhap-page-file.component';
import { DeNghiNhapKhoService } from '../../kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-page-service/kho-de-nghi-nhap-kho-page.service';
import { ThongTinHangVeService } from '../../kho-phieu-thong-tin-hang-ve-page/phieu-thong-tin-hang-ve-service-page/phieu-thong-tin-hang-ve.service';
import { DeNghiNhapKhoDetailDialogComponent } from '../../kho-de-nghi-nhap-kho-page/kho-de-nghi-nhap-kho-detail-dialog/kho-de-nghi-nhap-kho-detail-dialog.component';
import { ThongTinHangVeDetailDialogComponent } from '../../kho-phieu-thong-tin-hang-ve-page/phieu-thong-tin-hang-ve-detail-dialog/phieu-thong-tin-hang-ve-detail-dialog.component';

// import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
import { PhieuKiemKeDetailComponent } from '../../../chuc-nang-kho/phieu-kiem-ke/phieu-kiem-ke-detail/phieu-kiem-ke-detail.component';

@Component({
	selector: 'm-kho-phieu-nhap-kho-detail',
	templateUrl: './kho-phieu-nhap-kho-detail.component.html',
	styleUrls: ['../kho-nhap-kho-page.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})

export class NhapKhoPageDetailComponent implements OnInit{


	/* Các trường focus cho các tag trong form */
	@ViewChild(CdkVirtualScrollViewport, { static: false }) cdkVirtualScrollViewPort: CdkVirtualScrollViewport;
	@ViewChild('fileUploadImport', { static: false }) fileUploadImport : ElementRef;
	@ViewChildren('focusDetail') focusDetail;
	@ViewChildren("coChungTu") coChungTu;

	/*----------------------------Config Form ---------------------------*/
	CONFIG: CommonConFig;
	/* ------------------------------------------------------------------*/
	isShowSpinner:boolean=false;


    /*--------------------Comment columns mat-table----------------------*/
	displayedColumns = [];
	availableColumns = [
		// {
		// 	stt: 0,
        //     name: 'select',
        //     displayName: 'Check chọn',
		// 	alwaysChecked: true,
		// 	isShow: true
        // },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoXeSoMe',
            displayName: 'Số mẻ/số xe',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'MaThung',
            displayName: 'Mã thùng (TP)',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 10,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		// {
        //     stt: 11,
        //     name: 'SoMay',
        //     displayName: 'Số máy',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		{
            stt: 11,
            name: 'PalletText',
            displayName: 'PalletText',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'NgayNhan',
            displayName: 'Ngày nhận',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 15,
            name: 'GhiChu',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
        },
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	tmpAvailableColumns = [
		// {
		// 	stt: 0,
        //     name: 'select',
        //     displayName: 'Check chọn',
		// 	alwaysChecked: true,
		// 	isShow: true
        // },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 7,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoXeSoMe',
            displayName: 'Số mẻ/số xe',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'MaThung',
            displayName: 'Mã thùng (TP)',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 10,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'MaSub',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		// {
        //     stt: 11,
        //     name: 'SoMay',
        //     displayName: 'Số máy',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		{
            stt: 11,
            name: 'PalletText',
            displayName: 'PalletText',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'NgayNhan',
            displayName: 'Ngày nhận',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 12,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 13,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	phieuTTHVColumn = [
		// {
		// 	stt: 0,
        //     name: 'select',
        //     displayName: 'Check chọn',
		// 	alwaysChecked: true,
		// 	isShow: true
        // },
		{
			stt: 0,
			name: 'select',
			displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
		},
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 5,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPhieuDN',
            displayName: 'Số phiếu TTHV',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'Soluongchungtu',
			// displayName: 'SLKH',
			displayName: 'SL đề nghị',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'SoXeSoMe',
            displayName: 'Số mẻ/số xe',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'MaThung',
            displayName: 'Mã thùng (TP)',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPONCC',
            displayName: 'Số PO NCC',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 11,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'MaSub',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},

		{
            stt: 11,
            name: 'PalletText',
            displayName: 'PalletText',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'NgayNhan',
            displayName: 'Ngày nhận',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 13,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 15,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 15,
            name: 'GhiChu',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 15,
            name: 'disabled',
            displayName: 'Trạng thái',
            alwaysChecked: false,
			isShow: true
        },
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	phieuDNNKColumn = [
		{
			stt: 0,
            name: 'select',
            displayName: 'Check chọn',
			alwaysChecked: true,
			isShow: true
        },
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'MaHH',
            displayName: 'Mã hàng',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'TenHH',
            displayName: 'Tên hàng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 4,
            name: 'QuyCach',
            displayName: 'Quy cách',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPhieuDNNK',
            displayName: 'Số phiếu ĐNNK',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'SoluongchungtuDNNK',
			// displayName: 'SLKH',
			displayName: 'SL đề nghị',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'Soluongthucnhap',
            displayName: 'SL thực nhập',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 8,
            name: 'TenDVT',
            displayName: 'ĐVT',
            alwaysChecked: false,
			isShow: true
		},
        {
            stt: 9,
            name: 'Solo',
            displayName: 'Số lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 9,
            name: 'SoXeSoMe',
            displayName: 'Số mẻ/số xe',
            alwaysChecked: false,
			isShow: true
		},{
            stt: 9,
            name: 'MaThung',
            displayName: 'Mã thùng (TP)',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 6,
            name: 'SoPOKH',
            displayName: 'Số PO KH',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'IdKho',
            displayName: 'Kho',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 11,
            name: 'ViTriKho',
            displayName: 'Vị trí kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'MaSub',
            displayName: 'Mã sub lô',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'SoMay',
            displayName: 'Số máy',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 11,
            name: 'PalletText',
            displayName: 'PalletText',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 12,
            name: 'NgayNhan',
            displayName: 'Ngày nhận',
            alwaysChecked: false,
			isShow: true
        },
		{
			stt: 13,
			name: "NgayDongThung",
			displayName: "Ngày đóng thùng",
			alwaysChecked: false,
			isShow: true,
		},
		{
            stt: 13,
            name: 'NgaySanXat',
            displayName: 'Ngày sản xuất',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 14,
            name: 'Handung',
            displayName: 'Hạn sử dụng',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 15,
            name: 'Tag',
            displayName: 'Tags',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 15,
            name: 'Tinhtrang',
            displayName: 'Cho phép xuất kho',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 16,
            name: 'Phieukiemtracl',
            displayName: 'Số phiếu KTHH',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 16,
            name: 'GhiChu',
            displayName: 'Ghi chú',
            alwaysChecked: false,
			isShow: true
        },
		{
            stt: 15,
            name: 'disabled',
            displayName: 'Trạng thái',
            alwaysChecked: false,
			isShow: true
        },
		{
			stt: 99,
			name: 'actions',
			displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
		}
	];
	sumColums1: string[] = ['#','Soluongchungtu', 'Soluongthucnhap'];
	sumColums2: string[] = ['#','SoluongchungtuDNNK', 'Soluongthucnhap'];
	sumColums3: string[] = ['#', 'Soluongthucnhap'];

	sumColums: string[] = []
	/* ------------------------------------------------------------------*/


    /*--------------------Mat select search cho hàng hóa-----------------*/
	listId_HH : any[] = [];
	selectId_HH : string = '';
	filteredId_HH: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	Id_HHFilterCtrl: string = '';
	haveElementId_HH: boolean = false;
	sumRecord = 0;
	/* ------------------------------------------------------------------ */


    /*--------------------Mat select search cho nhân viên-----------------*/
	listIdNV : any[] = [];
	selectIdNV : string = '';
	filteredIdNV: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	IdNVFilterCtrl: string = '';
	haveElementIdNV: boolean = false;
	/* ------------------------------------------------------------------ */


    /*-------------------- Mat select search cho kho ---------------------*/
	listKho : any[] = [];
	selectKho : string = '';
	filteredKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrl: string = '';
	haveElementKho: boolean = false;
	arrayKhoForEachHH: any[] = [];

	listKhoVer2 : any[] = [];
	selectKhoVer2 : string = '';
	filteredKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	KhoFilterCtrlVer2: string = '';
	haveElementKhoVer2: boolean = false;
	/* ------------------------------------------------------------------ */


	/*----------------- Mat select search cho vị trí kho -----------------*/
	SaveListVTK: any[] = [];
	selectVTKho : string = '';
	filteredVTKho: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	VTKhoFilterCtrl: string = '';
	arrayVTKhoForEachHH: any[] = [];

	ListVTKVer2: any[] = [];
	selectVTKhoVer2: string = '';
	filteredVTKhoVer2: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
	VTKhoFilterCtrlVer2: string = '';
	/* ------------------------------------------------------------------ */


  	/*------------------------ Danh sách trạng thái ----------------------*/
	listState : any[] = [];
	nameState: string = '';
	/* ------------------------------------------------------------------ */


    /* ------------------------------Selection ---------------------------*/
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<ChiTietPhieuNhapKho>(true, []);
    /* ------------------------------------------------------------------ */


    /* --------------------------- Loading.... ---------------------------*/
	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();
	/* ------------------------------------------------------------------ */


	/* ------------------- Các form trên dialog --------------------------*/
	NKForm: FormGroup;				        //Form thông tin nhập kho
	HHForm: FormGroup;			            //Form add hàng hóa cho phiếu
	ImportHHForm: FormGroup;			    //Form import hàng hóa cho phiếu
	/* ------------------------------------------------------------------ */


	/*---------------------- Thông tin thao tác cho phiếu --------------- */
	NKItem: PhieuNhapKho;
	listChiTietNK: ChiTietPhieuNhapKho[] = [];
	tmpChiTietNK: ChiTietPhieuNhapKho[] = [];
	flagArrayTTHV :any[] = [];
	flagArrayDNNK :any[] = [];
	/* Danh sách tạm chi tiết đề nghị nhập kho để so sánh khi nhập số lượng trên lưới */
	deNghiNhapKhoResult: DeNghiNhapKhoChiTiet[] = [];

	/*Danh sách lưu ID các mặt hàng thêm mới cũng như đã xóa để lấy danh sách hàng hợp lý */
	deletedItems: number[] = [];
	addNewItems: number[] = [];
	/* ------------------------------------------------------------------ */


	/*------------------------- Extend field: ----------------------------*/
	title: string = '';
	previousIndex: number;
	fixedPoint = 2;
	isChange: boolean = false;
	saveAdded: number[] = []
	saveAddedCT: number[] = []
	viewLoading: boolean = false;
    disableNewButton: boolean = true;
	listNguoiThucHien: string[] = [];
	processImport: boolean = false;
	flagTab: number = 0;
	minDate: any;
	openTimKiemNangCao = false;
	optionsLoaiPhieu: any[] = [];
	flagChangeLoaiPhieu = "";
	openDialog: boolean = false;

	UPDATE = '1001100';
	HUY = '0606';

	LIST_ROLES_USER: [] = [];
	SHOW_BUTTON_UPDATE = new BehaviorSubject<boolean>(false);
	SHOW_BUTTON_REMOVE = new BehaviorSubject<boolean>(false);

	isUpdate = false;
	maxKLVTKDisable = 4000;
    /* ------------------------------------------------------------------ */
	// .. Tag Kho
	listTagFull: any[] = [];
	id: number = 0;
	// .....................
    constructor(
		@Optional() public dialogRef: MatDialogRef<NhapKhoPageDetailComponent>,
		@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
		private nhapKhoService: NhapKhoPageService,
		private pdfCustomService: JsPDFFontService,
		private soDoKhoService : SoDoKhoService,
		private NKFB: FormBuilder,
		public dialog: MatDialog,
		private router: Router,
		private subheaderService: SubheaderService,
		private activatedRoute: ActivatedRoute,
		private tokenStorage: TokenStorage,
		private changeDetect: ChangeDetectorRef,
		private layoutUtilsService: LayoutUtilsService,
		private thongTinHangVeService: ThongTinHangVeService,
		private deNghiNhapKhoService: DeNghiNhapKhoService,
		private dungChungService: DungChungService,
    ) {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.LIST_ROLES_USER = user.roles;
	}


    /*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load all dropdown and create form */
		this.ListKhoVer2();
		this.ListState();
		this.ListIdNv();
		this.ListTagKho();

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.optionsLoaiPhieu = PhieuNhapKho.optionsLoaiPhieu;
		this.NKItem = new PhieuNhapKho();
		this.NKItem.clear();
		this.createForm();

		this.activatedRoute.params.subscribe(params => {this.id = +params.id;});
		if (this.data && this.data.id) this.id = this.data.id;

		if (this.id && this.id > 0) {
			this.NKItem.IdNk = this.id;
			this.nhapKhoService.getItemById(this.id).subscribe(res => {
				if(res.status == 1){
					this.NKItem = res.data
					this.SHOW_BUTTON_REMOVE.next(this.isTrueButtonHuy(this.HUY));
					if(this.NKForm != null){
						this.bindingValueAfterCallAPIDetail();
					}
				}
			});
		} else {
			this.NKItem.Tinhtrang = PhieuNhapKho.optionsTinhTrang[0].value;
			this.dungChungService.getBillNumber(PhieuNhapKho.category_path).subscribe(res => {
				if (res.status == 1){
					this.NKItem.Sophieu = res.data;
					if(this.NKForm != null)
						this.NKForm.controls["SoPhieu"].setValue(this.NKItem.Sophieu);
				}
			});
		}

		this.SHOW_BUTTON_UPDATE.next(this.isTrueButton(this.UPDATE));

		let breadcrumbs = [{ title: 'Kho' }, { title: 'Nhập kho', page: '/nhap-kho'}, { title: 'Chi tiết phiếu nhập kho' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);
		this.title = this.getTitle();
		this.applyComlumnsAferChangeLoaiPhieu();
		this.showColumnsInTable();
		this.applySelectedColumns();

	}
	checkGroupPhieu(){
		return PhieuNhapKho.optionsLoaiPhieu.find(x => x.value == this.NKForm.controls["LoaiPhieu"].value).group
	}
	/* -----------------------------------------------------------------------*/
	getTotalNumber(){
		let total = 0;
		this.tmpChiTietNK.forEach(element => {
			  total +=  Number(element.KhoiLuongQuyDoi)
		});
		return total;
	}
	getTotalNumberSoluongchungtu(){
		let total = 0;
		this.tmpChiTietNK.forEach(element => {
			total += Number(element.Soluongkehoach)
		});
		return total;
	}
	getTotalNumberSoluongchungtuDNNK(){
		let total = 0;
		this.tmpChiTietNK.forEach(element => {
			total += Number(element.Soluongchungtu)
		});
		return total;
	}

	/*----------------- Create Form with appropriate sub forms ---------------*/
	createForm(){

		/*Get name of người lập phiếu */
		var tenNguoiLap = '';
		this.tokenStorage.getFullName().subscribe(t => { tenNguoiLap = t; });

		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		this.minDate = new Date();

		/*Group các Form */
		this.NKForm = this.NKFB.group({
			SoPhieu: [''],
			NgayLapPhieu: [new Date()],
			TenNguoiLap: [tenNguoiLap],
            TrangThai: [this.nameState],
            LoaiPhieu: [this.optionsLoaiPhieu[0].value, Validators.required],
            NgayNhapKho: [new Date(), Validators.required],
			NgayXacNhan:[new Date()],
			DSNguoiThucHien: [this.listNguoiThucHien,Validators.required],
			NguoiGiaoHang: [''],
			PhongBanGiaoHang: [''],
			FileChungTu: [''],
            DienGiai: [''],
			ChungTuKemTheo: [false],
			SoChungTu: ['']
		});

		this.flagChangeLoaiPhieu = this.NKForm.controls['LoaiPhieu'].value;
        this.NKForm.disable();
        this.changeDetectView();
	}
	bindingValueAfterCallAPIDetail(){
		if(this.NKItem.IdNk > 0){
			this.NKItem.listNguoiThucHien.forEach(element =>{
				this.listNguoiThucHien.push('' + element.NguoiThucHien);
			})

			this.NKForm.controls["SoPhieu"].setValue(this.NKItem.Sophieu);
			this.NKForm.controls["NgayLapPhieu"].setValue(this.strDate(this.NKItem.Ngaytao));
			this.NKForm.controls["TenNguoiLap"].setValue(this.NKItem.TenNguoitao);
			this.NKForm.controls["LoaiPhieu"].setValue(this.NKItem.LoaiPhieu.toString());
			this.NKForm.controls["NgayNhapKho"].setValue(this.NKItem.Ngaynhapkho);
			this.NKForm.controls["NgayXacNhan"].setValue(this.strDate(this.NKItem.Ngayxacnhan));
			this.NKForm.controls["DSNguoiThucHien"].setValue(this.listNguoiThucHien);
			this.NKForm.controls["DienGiai"].setValue(this.NKItem.DienGiai);
			this.NKForm.controls["NguoiGiaoHang"].setValue(this.NKItem.NguoiGiaoHang);
			this.NKForm.controls["PhongBanGiaoHang"].setValue(this.NKItem.PhongBanGiaoHang);
			this.NKForm.controls["FileChungTu"].setValue(this.NKItem.FileChungTu);
			this.NKForm.controls["SoChungTu"].setValue(this.NKItem.SoChungTu);
			this.NKForm.controls["ChungTuKemTheo"].setValue(this.NKItem.ChungTuKemTheo);

			this.checkState();

			this.flagChangeLoaiPhieu = this.NKForm.controls['LoaiPhieu'].value;

			this.applyComlumnsAferChangeLoaiPhieu();
			this.showColumnsInTable();
			this.applySelectedColumns();

			/*Add dữ liệu chi tiết*/
			if(this.NKItem.listChiTietPhieuNhapKho.length > 0){
				this.listChiTietNK = this.NKItem.listChiTietPhieuNhapKho;
				this.tmpChiTietNK = [];
				for(let i = 0; i < this.listChiTietNK.length; i++){
					let tmpElement = new ChiTietPhieuNhapKho();
					tmpElement.copy(this.listChiTietNK[i])
					this.tmpChiTietNK.push(tmpElement);


					let filterVTK = new ReplaySubject<any[]>(1)
					this.arrayVTKhoForEachHH.push(filterVTK);
					this.SaveListVTK.push([]);
					console.log(tmpElement)
					this.getDS_ViTriKho_Empty(tmpElement.IdKho,tmpElement);
				}

				this.tmpChiTietNK = [...this.tmpChiTietNK];
			} else {
				this.tmpChiTietNK = [];
				this.tmpChiTietNK = [...this.tmpChiTietNK];
			}
		}
	}
	changeChungTuKemTheo(value){
		var key = value;
		let form = this.NKForm.controls;

		// .. Xử lý do lý do 'Khác'
		if (key.checked){
			form['ChungTuKemTheo'].setValidators([Validators.required]);
			setTimeout(() => this.coChungTu.first.nativeElement.focus(), 500);
		}
		else{
			form['SoChungTu'].clearValidators();
			form['SoChungTu'].setValue("");
		}
		form['SoChungTu'].updateValueAndValidity();
		this.changeDetect.detectChanges();
	}
	isSelectedCoChungTu(){
		let form  = this.NKForm.controls;
		let value = form["ChungTuKemTheo"].value;
		return value ;
	}
	getTitle(): string {
		return 'Chi tiết phiếu nhập kho';
    }
    getNameButtonDS(): string{
        // if(this.NKForm.controls["LoaiPhieu"].value == PhieuNhapKho.optionsLoaiPhieu[0].value){
        //     return 'Chọn hàng từ phiếu TTHV';
        // }
		// else if(this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[1].value
		// || this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[2].value
		// || this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[3].value){
		// 	return 'Chọn hàng từ phiếu ĐNNK';
		// }
		return 'Chọn hàng từ phiếu ĐNNK';
        return '';
	}
	isCreate(){
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		if(this.NKItem != null && (this.NKItem.Nguoitao == +idUser || this.NKItem.listNguoiThucHien.findIndex(x => +x.NguoiThucHien == +idUser) > -1)
		&& (this.NKItem.Tinhtrang == PhieuNhapKho.optionsTinhTrang[0].value || this.NKItem.Tinhtrang == PhieuNhapKho.optionsTinhTrang[1].value)
		){
			return true;
		}
		return false;
	}
	getListSelected() {
		var list = this.tmpChiTietNK.map(x => {
			var rObj = {};
			rObj["IdDn"] = x.IdDn;
			rObj["SoPhieuDN"] = x.SoPhieuDN;
			return rObj;
		});
		var unique = [];
		list.forEach(x => {
			if (unique.filter(a => a.IdDn == x["IdDn"]).length == 0)
				unique.push(x);
		});
		return unique;
	}
	open_dialog_kk(IdKk: number) {
		this.openDialog = true;
		const dialogRef = this.dialog.open(PhieuKiemKeDetailComponent, {
			data: {
				IdKk: IdKk,
				canEdit: false,
			},
			maxHeight: "90vh",
			width: "90vw",
		});
	}
	open_dialog_detail(__iddn: number) {
		this.openDialog = true;
		this.deNghiNhapKhoService.getItemById(__iddn).subscribe(res => {
			if (res.status == 1) {
				const dialogRef = this.dialog.open(DeNghiNhapKhoDetailDialogComponent, {
					data: {
						data: res.data,
						canEdit: false
					},
					maxHeight: '90vh',
					width: '90vw'
				});
				dialogRef.afterClosed().subscribe(res => {
					setTimeout(() => {
						this.openDialog = false;
					}, 50);
				});
			} else {
				this.openDialog = false;
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
		// if (this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[1].value
		// || this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[2].value
		// || this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[3].value) {
		// 	this.deNghiNhapKhoService.getItemById(__iddn).subscribe(res => {
		// 		if (res.status == 1) {
		// 			const dialogRef = this.dialog.open(DeNghiNhapKhoDetailDialogComponent, {
		// 				data: {
		// 					data: res.data,
		// 					canEdit: false
		// 				},
		// 				maxHeight: '90vh',
		// 				width: '90vw'
		// 			});
		// 			dialogRef.afterClosed().subscribe(res => {
		// 				setTimeout(() => {
		// 					this.openDialog = false;
		// 				}, 50);
		// 			});
		// 		} else {
		// 			this.openDialog = false;
		// 			this.layoutUtilsService.showErorr(res.error.message);
		// 		}
		// 	});
		// }
		// else if (this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[0].value) {
		// 	this.thongTinHangVeService.getItemById(__iddn).subscribe(res => {
		// 		if (res.status == 1) {
		// 			const dialogRef = this.dialog.open(ThongTinHangVeDetailDialogComponent, {
		// 				data: {
		// 					data: res.data,
		// 					canEdit: false
		// 				},
		// 				maxHeight: '90vh',
		// 				width: '90vw'
		// 			});
		// 			dialogRef.afterClosed().subscribe(res => {
		// 				setTimeout(() => {
		// 					this.openDialog = false;
		// 				}, 50);
		// 			});
		// 		} else {
		// 			this.openDialog = false;
		// 			this.layoutUtilsService.showErorr(res.error.message);
		// 		}
		// 	});
		// }
	}
	/* -----------------------------------------------------------------------*/


	/*--------- Các hàm hỗ trợ hiển thị các cột và chuyển cột trong bảng------*/
	showColumnsInTable(){
		for(let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].isShow == false){
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string){
		for( let i = 0; i < this.availableColumns.length; i++){
			if(this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for(let i = 0; i < this.availableColumns.length; i++){
			this.selectedColumns.toggle(this.availableColumns[i]);
			for( let j = 0; j < _selectedColumns.length; j++){
				if( this.availableColumns[i].name == _selectedColumns[j].name){
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
	applyComlumnsAferChangeLoaiPhieu(){
		if(PhieuNhapKho.optionsLoaiPhieu.find(x => x.value == this.NKForm.controls["LoaiPhieu"].value).group == "TTHV"){
			this.availableColumns = this.phieuTTHVColumn
			this.sumColums = this.sumColums1;
		}
		else if(PhieuNhapKho.optionsLoaiPhieu.find(x => x.value == this.NKForm.controls["LoaiPhieu"].value).group == "DNNK"){
			this.availableColumns = this.phieuDNNKColumn
			this.sumColums = this.sumColums2;
		}
		else{
			this.availableColumns = this.tmpAvailableColumns
			this.sumColums = this.sumColums3;

		}
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- Hàm lấy danh sách-----------------------------*/
	ListState(){
		this.dungChungService.listState(PhieuNhapKho.category_path).subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listState = res.data;
				this.checkState();
				this.changeDetectView();
			};
		});
	}
	checkState(){
		this.listState.forEach(element => {
			if(element.Code == this.NKItem.Tinhtrang){
				this.nameState = element.Description;
				if(this.NKForm != null)
					this.NKForm.controls["TrangThai"].setValue(this.nameState);
			}
		});
	}

	ListKho(){
		this.dungChungService.listKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKho = res.data;
				this.tmpChiTietNK.forEach(element =>{
					let filterTmp = new ReplaySubject<any[]>(1)
					filterTmp.next(this.listKho.slice());
					this.arrayKhoForEachHH.push(filterTmp);
				})
				this.changeDetectView();
			};
		});
	}
	filterListKho(item: any) {
		if (!this.listKho) {
			return;
		}
		let search = this.KhoFilterCtrl;
		let index = this.tmpChiTietNK.indexOf(item)

		if (!search) {
			this.arrayKhoForEachHH[index].next(this.listKho.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		if(index > -1){
			this.arrayKhoForEachHH[index].next(this.listKho.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	ListKhoVer2(){
		this.dungChungService.listKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listKhoVer2 = res.data;
				if(this.listKhoVer2 && this.listKhoVer2.length > 0){
					this.maxKLVTKDisable = this.listKhoVer2[0].MaxSLVTK;
				}
				this.filteredKhoVer2.next(this.listKhoVer2.slice());
				this.changeDetectView();
			};
		});
	}
	filterListKhoVer2() {
		if (!this.listKhoVer2) {
			return;
		}
		let search = this.KhoFilterCtrlVer2;
		if (!search) {
			this.filteredKhoVer2.next(this.listKhoVer2.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredKhoVer2.next(
			this.listKhoVer2.filter(ts =>
				ts.TenKho.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	getNameOfKho(IdKho: number){
		let name = '';
		this.listKhoVer2.forEach(element =>{
			if(element.Id_Kho == IdKho){
				name = element.TenKho
			}
		})
		return name;
	}
	getMaKho(IdKho: number){
		let name = '';
		this.listKhoVer2.forEach(element =>{
			if(element.Id_Kho == IdKho){
				name = element.MaKho + ' - ' + element.TenKho
			}
		})
		return name;
	}

	getDS_ViTriKho_EmptyVer2(IdKho: any){
		if(IdKho == null || IdKho == 0){
			this.ListVTKVer2 = [];
			return;
		}
		this.filteredVTKhoVer2.next([]);
		this.HHForm.controls['ViTriKho'].setValue('');

		let listVTK_Empty = [];
		let listVTK_Full = [];
		let hKho = 1, hKhoMax = 0;
		let cKho = 1, cKhoMax = 0;
		let tKho = 1, tKhoMax = 0;
		this.nhapKhoService.getDSVTK(Number(IdKho)).subscribe(res => {
			if(res && res.status == 1){
				if(res.data != null){
					listVTK_Full = res.data.listVTK;
					hKhoMax = res.data.hKho;
					cKhoMax = res.data.cKho;
					tKhoMax = res.data.tKho;
					for(let t = tKho; t <= tKhoMax; t++){
						for(let c = cKho; c <= cKhoMax; c++){
							for(let h = hKho; h <= hKhoMax; h++){
								let value = this.lpad(h,3)+"."+this.lpad(c,3)+"."+this.lpad(t,2);
								if(listVTK_Full.findIndex(x => x == value) == -1){
									listVTK_Empty.push(value);
								}
							}
						}
					}
					this.ListVTKVer2 = listVTK_Empty;
					this.filteredVTKhoVer2.next(listVTK_Empty.slice());
					this.changeDetectView();
				}
				else{
					this.ListVTKVer2 = [];
					this.filteredVTKhoVer2.next(this.ListVTKVer2.slice());
				}
			}
		});
		this.isDisableButton();
	}
	filterListVTKhoVer2() {
		if (!this.ListVTKVer2) {
			return;
		}
		let search = this.VTKhoFilterCtrlVer2;
		if (!search) {
			this.filteredVTKhoVer2.next(this.ListVTKVer2.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredVTKhoVer2.next(
			this.ListVTKVer2.filter(ts =>
				ts.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	clearViTriKho(event: any){
		this.HHForm.controls["ViTriKho"].setValue('');
		event.stopPropagation();
		this.changeDetectView();
	}
	chonViTriKho(IdKho: any,type: number, index:any){
		let _index = this.listKho.findIndex(x => x.Id_Kho == IdKho);
		if(_index > -1){
			if(this.listKho[_index].CoSoDoKho){
				const dialogRef = this.dialog.open(SoDoKhoViewVer2Component, {
					data: {
						data: this.listKho[_index],
						type: type,
						currentSelected: type == 0 ? this.HHForm.controls['ViTriKho'].value : this.tmpChiTietNK[index].ViTriKho
					},
					maxHeight: '90vh',
					width: '90vw'
				});
				dialogRef.afterClosed().subscribe(res => {
					if (res == undefined || res == null) {
						return;
					}
					else {
						if (res.vitrikho != null && res.vitrikho != '') {

							if(type == 0)
								this.HHForm.controls["ViTriKho"].setValue(res.vitrikho[0])
							else if(type == 1){
								this.tmpChiTietNK[index].ViTriKho = res.vitrikho[0];
								for(let i = 1; i < res.vitrikho.length; i++){
									let tmp = new ChiTietPhieuNhapKho();
									tmp.copy(this.tmpChiTietNK[index]);
									tmp.ViTriKho = res.vitrikho[i];
									tmp.Soluongthucnhap = PhieuNhapKho.DEFAULT_NUMBER_VALUE;

									this.tmpChiTietNK.push(tmp);

									let filterTmp = new ReplaySubject<any[]>(1)
									filterTmp.next(this.listKho.slice());
									this.arrayKhoForEachHH.push(filterTmp);

									let filterVTK = new ReplaySubject<any[]>(1)
									this.arrayVTKhoForEachHH.push(filterVTK);
									this.SaveListVTK.push([]);

									this.getDS_ViTriKho_Empty(tmp.IdKho,tmp);
									this.tmpChiTietNK = [...this.tmpChiTietNK];
								}

							}
							this.changeDetectView();
						}
					}
				});
			}
			else{
				this.layoutUtilsService.showErorr('Kho chưa thiết lập sơ đồ kho');
				return;
			}
		}
		else{
			this.layoutUtilsService.showErorr('Không tìm được thông tin kho đang chọn');
			return;
		}
	}

	ListIdNv(){
		var phongban = '';
		this.tokenStorage.getCoCauId().subscribe(t => { phongban = t; });
		this.dungChungService.listNV().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listIdNV = res.data;
				this.filteredIdNV.next(this.listIdNV.slice());
				this.changeDetectView();
			};
		});
	}
	filterIdNv() {
		if (!this.listIdNV) {
			return;
		}
		let search = this.IdNVFilterCtrl;
		if (!search) {
			this.filteredIdNV.next(this.listIdNV.slice());
			return;
		} else {
			search = search.toLowerCase();
		}
		this.filteredIdNV.next(
			this.listIdNV.filter(ts =>
				ts.TenNV.toLowerCase().indexOf(search) > -1)
		);
		this.changeDetectView();
	}
	clearSelectNV(event: any){
		this.NKForm.controls["DSNguoiThucHien"].setValue('');
		event.stopPropagation();
	}

	ListId_HH(){
		this.dungChungService.listHangHoa().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listId_HH = res.data;
				this.sumRecord = this.listId_HH.length;
				this.filteredId_HH.next(this.listId_HH.slice());
				this.changeDetectView();
			};
		});
	}
	filterId_HH(searchTmp: string = '') {
		if (!this.listId_HH) {
			return;
		}
		// get the search keyword
		let search = this.Id_HHFilterCtrl;
		if(searchTmp != '' && searchTmp != null)
			search = '' + searchTmp;

		if (!search) {
			this.sumRecord = this.listId_HH.length;
			this.filteredId_HH.next(this.listId_HH.slice());
			return;
		} else {
			search = search.toLowerCase();
		}

		if(searchTmp != ''){
			this.sumRecord = this.listId_HH.filter(ts =>ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.Ma_Ten_HH.toLowerCase().indexOf(search) > -1)
			);
		}
		else{
			this.sumRecord = this.listId_HH.filter(ts => ts.MaHang.toLowerCase().indexOf(search) > -1).length;
			this.filteredId_HH.next(
				this.listId_HH.filter(ts =>
					ts.MaHang.toLowerCase().indexOf(search) > -1)
			);
		}

		this.changeDetectView();
	}
	afterSelectHH(value:string){
		this.listId_HH.forEach( element => {
			if(element.Id_HH == +value){
				this.selectId_HH = value;
				this.HHForm.controls["MaHang"].setValue(element.MaHH);
				this.HHForm.controls["MaHang"].disable();
				this.HHForm.controls["TenHang"].setValue(element.TenHH);
				this.HHForm.controls["QuyCach"].setValue(element.QuyCach);
				this.HHForm.controls["DVT"].setValue(element.TenDVT);
				//this.validateInvalidSubForm();
			}
		});
		this.isDisableButton();
	}
	clearSelectHH(event: any){
		this.selectId_HH = '';
		this.HHForm.controls["MaHang"].setValue('');
		this.HHForm.controls["MaHang"].enable();

		this.HHForm.controls["TenHang"].setValue('');
		this.HHForm.controls["QuyCach"].setValue('');
		this.HHForm.controls["DVT"].setValue('');
		this.sumRecord = this.listId_HH.length;

		event.stopPropagation();
		this.isDisableButton();
	}
	checkCanPhieuKT(item: ChiTietPhieuNhapKho){
		let index = this.listId_HH.findIndex(x => x.Id_HH == item.IdHh)
		if(!item.flagKT)
			return true;
		if(index > -1 && this.listId_HH[index].CanPhieuKT != null
			&& this.listId_HH[index].CanPhieuKT != undefined && !this.listId_HH[index].CanPhieuKT){
			return true;
		}
		return false;
	}
	isRequiredPhieuKT(item: ChiTietPhieuNhapKho){
		if(!this.checkCanPhieuKT(item) && item.Tinhtrang
				&& (item.Phieukiemtracl == null || item.Phieukiemtracl == '')){
			return true;
		}
		return false;
	}

	changeLoaiPhieu(){
		this.listChiTietNK = [];
		this.tmpChiTietNK = [];
		this.tmpChiTietNK = [...this.tmpChiTietNK];
		this.arrayVTKhoForEachHH = [];
		this.arrayKhoForEachHH = [];
		this.SaveListVTK = [];
		this.flagArrayDNNK = [];
		this.flagArrayTTHV = [];

		this.HHForm.reset();
		this.HHForm.controls["SoLuong"].setValue(PhieuNhapKho.DEFAULT_NUMBER_VALUE);
		this.HHForm.controls["HanSuDung"].setValue(new Date());
		this.HHForm.controls["MaHang"].enable();
		this.selectId_HH = '';
		this.filteredId_HH.next(this.listId_HH.slice());

		this.ImportHHForm.reset();

		this.listKhoVer2 = [];
		this.filteredVTKhoVer2 = new ReplaySubject<any[]>(1);

		this.NKForm.controls["DienGiai"].setValidators(null);
		this.NKForm.controls['DienGiai'].updateValueAndValidity()

		// if(this.NKForm.controls['LoaiPhieu'].value == PhieuNhapKho.optionsLoaiPhieu[2].value){
		// 	this.NKForm.controls["DienGiai"].setValidators([Validators.required]);
		// 	this.NKForm.controls['DienGiai'].updateValueAndValidity()
		// }

		this.applyComlumnsAferChangeLoaiPhieu();
		this.applySelectedColumns();
		this.changeDetectView();
	}
	valueCheckboxChange(index:number, event: any){
		if(event != null && event != undefined)
			this.tmpChiTietNK[index].Tinhtrang = event.checked;
	}
	/* -----------------------------------------------------------------------*/
	changeDVTItem(index) {
		let _detail = this.tmpChiTietNK[index];
		if (_detail) {
			if (_detail.listDVTInfo && _detail.listDVTInfo.length > 0) {
				let currentDVT = _detail.listDVTInfo.find((x) => x.IdDVT == _detail.DvtQuyDoi);
				if (currentDVT) {
					_detail.Soluongthucnhap = "" + Number(_detail.KhoiLuongQuyDoi) * Number(currentDVT.QuyDoiDVT);
				}
			}
			this.tmpChiTietNK = [...this.tmpChiTietNK];
			this.changeDetectView();
		}
	}
	cvInputListNumber(columnName: string, event: any, min: number = 0, item: any) {
		const VALUE_EMPTY = "";
		const MIN_VALUE = min;
		const REGEX_COMMA = /,/g;
		const INDEX_ZERO = 0;
		const VALUE_DEFAULT = 0.0;
		var value = item[columnName];
		var evtValue = event.target.value;
		var evtTarget = event.target;
		if (evtValue == VALUE_EMPTY || evtValue.toString() == value.toString()) {
			if (evtValue == VALUE_EMPTY) evtTarget.value = this.f_number(MIN_VALUE);
			if (evtValue.toString() == value.toString()) evtTarget.value = this.f_number(value);
			evtTarget.selectionStart = INDEX_ZERO;
			evtTarget.selectionEnd = INDEX_ZERO;
		}
		if (!this.ValidateChangeNumberForm(event)) {
			item[columnName] = MIN_VALUE;
			return false;
		}
		if (isNaN(evtValue)) evtValue = VALUE_DEFAULT;
		if (Number(evtValue) < min) evtValue = MIN_VALUE;
		if (!item[columnName]) item[columnName] = MIN_VALUE;
		item[columnName] = evtValue;
		evtTarget.value = this.f_number(evtValue);
		this.changeDetect.detectChanges();
	}
  	/*------------------ Hàm hỗ trợ format các dạng số trên form -------------*/
	showErrorInputSL(columnName: string, formGroup: any, name: string){
		let message = "";
		let controls = formGroup.controls;
		if(controls[columnName].value.length == 0 || this.formatComparenumber(controls[columnName].value) == 0) return name + ' là bắt buộc';
		if(controls[columnName].hasError('maxlength')
			|| (controls[columnName].value.length > 22
				&& (controls[columnName].value.indexOf(',') == 0 || controls[columnName].value.indexOf(',') > 21)))
			return 'Tối đa 18 chữ số với 2 chữ số thập phân';
		return message;
	}
	ValidateChangeNumberForm(event: any, isEvent:boolean = true) {
		var count = 0;
		if(isEvent){
			for(let i = 0; i < event.target.value.length; i++){
				if(event.target.value[i] == ','){
					count += 1;
				}
			}
		}
		else{
			event = "" + event
			for(let i = 0; i < event.length; i++){
				if(event[i] == ','){
					count += 1;
				}
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = isEvent ? event.target.value.match(regex) : event.match(regex);
		if (found != null) {
			const message = 'Số lượng không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Số lượng không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		if (typeof (item) === "string") {
			item = item.replace(/,/g, "");
		}
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	formatComparenumber(number: string){
		return +number.replace(/\./g, "").replace(/,/g, ".");;
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0,value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1),(this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
	f_currency_VND(value: string): any {
		if (value == null || value == undefined) return PhieuNhapKho.DEFAULT_NUMBER_VALUE;
		return new Intl.NumberFormat('de-DE',{ style: 'decimal', currency: 'VND', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value));
	}
	f_number(item: any = "0.00"){
		return FunctionPublic.F_NUMBER_DYNAMIC(item, 5);
	}
	keyUpInputNumberVND(event){
		FunctionPublic.preventAlphaV2(event);
	}
	changeInputNumberVND(event, columnName, min: number = 0, formGroup){
		let controls = formGroup.controls;
		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9)
			{ return; }

			let data = FunctionPublic.slListChangedV2(event);
			if(data){
				if(this.f_number(data) < min && event.data && event.data == '0') data = this.f_number((min));
				controls[columnName].setValue(data);
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;

				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}

			}else{
				controls[columnName].setValue(this.f_number((min)));
			}
		}
	}
	changeInputOfFormVND(controlName: string, event: any, min: number = 0, formGroup){
		let controls = formGroup.controls;
		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = controls[controlName].value.replace(/\./g, "").replace(/,/g, ".");

			if(Number(tmpValue) < min) tmpValue = min;

			if(!controls[controlName].invalid){
				controls[controlName].setValue(
					this.f_number((tmpValue))
				);
			}
			if(tmpValue.indexOf(',') == 0 && tmpValue.length == 1){
				tmpValue = min;
			}
			controls[controlName].setValue(
				this.f_number((tmpValue))
			);
		}
		else{
			controls[controlName].setValue(this.f_number((min)));
		}
	}
	changeInputNumberVNDInList(event : any, min: number = 0){

		let position = event.target.selectionStart;
		let sizeStart = event.target.value.toString().length;
		let sizeEnd = sizeStart;
		var regex = /[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ]/g;
		var found = event.target.value.match(regex);
		if (found != null) {
			event.preventDefault();
		}
		else{
			if (event.keyCode === 46 || event.keyCode === 37 || event.keyCode === 39 || event.keyCode === 8 || event.keyCode === 9)
			{ return; }

			let data = FunctionPublic.slListChangedV2(event);
			console.log(data)
			if(data){
				if(this.f_number(data) < min && event.data && event.data == '0') data = this.f_number(min);
				event.target.value = data;
				sizeEnd = data.toString().length;
				let balance = sizeEnd - sizeStart;
				event.target.selectionStart = position + balance;
				event.target.selectionEnd = position + balance;
				if(data.length == 4){
					event.target.selectionStart = position;
					event.target.selectionEnd = position;
				}
			}else{
				event.target.value = this.f_number((min));
			}
		}
	}
	changeInputOfFormVNDInList(columnName: string, event: any, min: number = 0, item: DeNghiNhapKhoChiTiet){

		if(this.ValidateChangeNumberForm(event)){
			let tmpValue = this.f_number(event.target.value.toString());

			if(Number(tmpValue) < min) tmpValue = min;

			if(!item[columnName]){
				item[columnName] = tmpValue.toString();
			}

			if(tmpValue.toString().indexOf(',') == 0 && tmpValue.toString().length == 1){
				tmpValue = min;
			}
			item[columnName] =tmpValue.toString();
		}
		else{
			item[columnName] = min.toString();
		}

		this.changeDetectView();
	}
	lpad(value, padding) {
		var zeroes = new Array(padding+1).join("0");
		return (zeroes + value).slice(-padding);
	}
	/* -----------------------------------------------------------------------*/


	/*----------------- Hàm hỗ trợ format các dạng ngày trên form ------------*/
	getFormatDate(v: string = '') {
        if (v != null && v!= undefined && v != '') {
            return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
        }
        return '';
	}
	f_convertDate(p_Val: any) {
		if(p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	minMaxDate(p_Val: any, item: any) {
		let d1 = new Date(p_Val);
		let d2 = new Date();

		if (d1.getTime() < d2.getTime()){
			this.tmpChiTietNK[this.tmpChiTietNK.indexOf(item)].Handung =  moment(new Date()).format('YYYY-MM-DD[T]HH:mm:ss.SSS');
			this.tmpChiTietNK = [...this.tmpChiTietNK];
		}
		this.changeDetectView();
	}
	get_date_nhap_kho(){
		var date = new Date(this.NKForm.controls['NgayNhapKho'].value);
		return "Ngày "+("0" + date.getDate().toString()).slice(-2)+ " tháng "+ ("0" + (date.getMonth() + 1).toString()).slice(-2) + " năm "+ date.getFullYear();
	}
    /* -----------------------------------------------------------------------*/


    /*---------------------------- Thao tác trên form ------------------------*/
	back(){
		if (this.data && this.data.id)
			this.dialogRef.close();
		else
			this.router.navigateByUrl('nhap-kho', { relativeTo: this.activatedRoute });
	}
	onSubmit(){
		for(let i = 0; i < this.tmpChiTietNK.length; i++){
			if(!this.tmpChiTietNK[i].isError){
				if(!this.checkCanPhieuKT(this.tmpChiTietNK[i]) && this.tmpChiTietNK[i].Tinhtrang
						&& (this.tmpChiTietNK[i].Phieukiemtracl == null || this.tmpChiTietNK[i].Phieukiemtracl == '')){
					this.layoutUtilsService.showErorr('Vui lòng nhập số phiếu KTHH cho mã hàng ' + this.tmpChiTietNK[i].MaHH);
					return null;
				}
			}
		}
		this.NKItem.listChiTietPhieuNhapKho = this.tmpChiTietNK;

		this.nhapKhoService.updateHHState(this.NKItem).subscribe(res => {
			if (res.status == 1){
				this.layoutUtilsService.showInfo('Cập nhật thành công');

				let index = this.saveAdded.findIndex(x => x == res.data.IdNk);
				if(index == -1)
					this.saveAdded.push(res.data.IdNk);
				this.nhapKhoService.dataNew$.next(this.saveAdded)
			}
			else{
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	confirmVT(){
		const dialogRef = this.layoutUtilsService.POPConfirm('Bạn chắc chắn xác nhận VT lưu kho');

			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.nhapKhoService.XacNhanVTLuuKho(this.NKItem.IdNk).subscribe(res => {
					if (res.status == 1){
						this.layoutUtilsService.showInfo('Xác nhận VT lưu kho thành công');

						let index = this.saveAdded.findIndex(x => x == this.NKItem.IdNk);
						if(index == -1)
							this.saveAdded.push(this.NKItem.IdNk);
						this.nhapKhoService.dataNew$.next(this.saveAdded)
						this.back();
					}
					else{
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});
			});
	}
	confirmVTDetail(){
		const dialogRef = this.layoutUtilsService.POPConfirm('Bạn chắc chắn xác nhận VT lưu kho');

			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				let input = this.selection.selected.map(item => item.IdCtnk)
				this.isShowSpinner = true;
				this.changeDetectView();
				this.nhapKhoService.XacNhanVTLuuKhoDetail(input).subscribe(res => {
					this.isShowSpinner = false;

					if (res.status == 1){
						this.layoutUtilsService.showInfo('Xác nhận VT lưu kho thành công');

						let index = this.saveAdded.findIndex(x => x == this.NKItem.IdNk);
						if(index == -1)
							this.saveAdded.push(this.NKItem.IdNk);
						this.nhapKhoService.dataNew$.next(this.saveAdded)
						this.back();
					}
					else{
						this.layoutUtilsService.showErorr(res.error.message);
					}
					this.changeDetectView();
				});
			});
	}
	changeVTK(item){
		const dialogRef = this.layoutUtilsService.POPConfirm('Bạn chắc chắn muốn thay đổi VTK');

			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.nhapKhoService.ChangeVTK(item).subscribe(res => {
					if (res.status == 1){
						this.layoutUtilsService.showInfo('VTK cập nhật thành công');
					}
					else{
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});
			});
	}
	ChangeSL(item){
		const dialogRef = this.layoutUtilsService.POPConfirm('Bạn chắc chắn muốn thay đổi số lượng');

			dialogRef.afterClosed().subscribe(res => {
				if (!res) {
					return;
				}
				this.nhapKhoService.ChangeSL(item).subscribe(res => {
					if (res.status == 1){
						this.layoutUtilsService.showInfo('Số lượng cập nhật thành công');
					}
					else{
						this.layoutUtilsService.showErorr(res.error.message);
					}
				});
			});
	}

	isTrueButton(ROLENUMBER: string) {
		if ((this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) &&
		(this.NKItem.Tinhtrang == PhieuNhapKho.optionsTinhTrang[0].value || this.NKItem.Tinhtrang == PhieuNhapKho.optionsTinhTrang[1].value)) {
			if(ROLENUMBER == this.UPDATE){
				this.isUpdate = true;
			}
			return true;
		}
		return false;
	}
	isTrueButtonHuy(ROLENUMBER: string) {
		if ((this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) &&
		(this.NKItem.Tinhtrang == PhieuNhapKho.optionsTinhTrang[1].value || this.NKItem.Tinhtrang == PhieuNhapKho.optionsTinhTrang[3].value)) {
			return true;
		}
		return false;
	}
	exportExcel(){
		if(this.selection.selected.length == 0){
			this.layoutUtilsService.showErorr('Vui lòng chọn hàng để xuất file!');
			return;
		}

		if(this.selection.selected.length >= 2){
			for(let i = 0; i < this.selection.selected.length; i++){
				if(this.selection.selected[i].IdNcc != this.selection.selected[0].IdNcc
					|| this.selection.selected[i].IdKho != this.selection.selected[0].IdKho){

					this.layoutUtilsService.showErorr('Vui lòng chọn các mặt hàng cùng kho và cùng nhà cung cấp!');
					return;
				}
			}
		}

		if(this.NKItem.LoaiPhieu == 'Nhập kho hàng NCC giao'){
			this.dungChungService.getNCCById(this.selection.selected[0].IdNcc).subscribe( res => {
				if(res && res.status === 1) {

					var result = res.data;
					var listId: number[] = [];
					this.selection.selected.forEach(element =>{
						listId.push(element.IdCtdn);
					})
					this.nhapKhoService.getListGhiChu(listId).subscribe(resAPI =>{
						if(resAPI.status === 1){
							this.exportExcelInfo(result, resAPI.data);
						}
					})
				}
			});
		}
		else{
			this.exportExcelInfo(null)
		}
	}
	exportExcelInfo(nccInfo: any, ghichu: string = ''){

		let head = [['#', 'Mã hàng', 'Tên hàng', 'Số lô', 'Hạn sử dụng', 'Mã kho','ĐVT','Số lượng','Đơn giá','Thành tiền']]
		let dataTable =[{
			'#': 'A',
			'MaHH': 'B',
			'TenHH': 'C',
			'Solo': 'D',
			'HanSuDung': 'E',
			'MaKho': 'F',
			'TenDVT': 'G',
			'SL': '1',
			'DG': '2',
			'TT': '3'
		}];

		var total = 0;
		for(let i = 0; i < this.selection.selected.length; i++){
			let element = this.selection.selected[i]
			dataTable.push({
				'#' : (i + 2) + '',
				'MaHH': element.MaHH,
				'TenHH': element.TenHH,
				'Solo': element.Solo,
				'HanSuDung': element.Handung == null ? '' : this.getFormatDate(element.Handung),
				'MaKho': element.MaKho,
				'TenDVT': element.TenDVT,
				'SL': element.Soluongthucnhap,
				'DG': '',
				'TT': ''
			});
		}

		var dataRow = [];
		dataTable.forEach((element,index) =>{
			if(index == 0){
				dataRow.push([
					{content: element["#"], styles: { halign: 'center' }},
					{content: element.MaHH, styles: { halign: 'center' }},
					{content: element.TenHH, styles: { halign: 'center' }},
					{content: element.Solo, styles: { halign: 'center' }},
					{content: element.HanSuDung, styles: { halign: 'center' }},
					{content: element.MaKho, styles: { halign: 'center' }},
					{content: element.TenDVT, styles: { halign: 'center' }},
					{content: index == 0 ? '1' : '', styles: { halign: 'center' }},
					{content: index == 0 ? '2' : '', styles: { halign: 'center' }},
					{content: index == 0 ? '3' : '', styles: { halign: 'center' }},
				])
			}
			else{
				dataRow.push([
					{content: index, styles: { halign: 'center' }},
					{content: element.MaHH, styles: { halign: 'left' }},
					{content: element.TenHH, styles: { halign: 'left' }},
					{content: element.Solo, styles: { halign: 'left' }},
					{content: element.HanSuDung, styles: { halign: 'left' }},
					{content: element.MaKho, styles: { halign: 'left' }},
					{content: element.TenDVT, styles: { halign: 'left' }},
					{content: this.f_currency(this.formatNumber(element.SL)), styles: { halign: 'right' }},
					{content: ''},
					{content: ''},
				])
			}
		})
		dataRow.push([
			{content: (''), styles: { halign: 'center' }},
			{content:'Cộng', colSpan: 5, styles: { halign: 'center', fontStyle: 'bold', } },
			{content:''},
			{content:''},
			{content: `${total == 0 ? '' : this.f_currency(this.formatNumber('' + total))}`}
		])

		var doc = new jsPDF();
		this.pdfCustomService.AddFontRoboto(doc);
		let x = 10; let y = 15;
		var xOffset = (doc.internal.pageSize.width / 2 - 10);

		doc.setFontSize(10);
		doc.setFontType("normal");
		doc.text(x,y, 'CÔNG TY TNHH THỰC PHẨM NFC');
		y += 7;
		doc.text(x,y, 'Đường số 8, KCX Nhơn Trạch 1, xã Phước Thiên, huyện Nhơn Trạch, tỉnh Đồng Nai, Việt Nam');
		y += 12;

		doc.setFontType("bold");
		doc.setFontSize(12);
		var textWidth = doc.getStringUnitWidth('PHIẾU NHẬP KHO') * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
		doc.text(textOffset, y, 'PHIẾU NHẬP KHO');
		y += 7;

		doc.setFontSize(10);
		doc.setFontType("bolditalic");
		var formatDate = this.getFormatDate(this.NKItem.Ngaynhapkho).split("/")
		var textWidth = doc.getStringUnitWidth('Ngày ' + formatDate[0] + ' tháng ' + formatDate[1] + ' năm ' + formatDate[2]) * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;

		doc.text(textOffset, y, 'Ngày ' + formatDate[0] + ' tháng ' + formatDate[1] + ' năm ' + formatDate[2]);
		doc.setFontType("normal");
		doc.text(160, y, 'TK nợ:');
		y += 7;
		var textWidth = doc.getStringUnitWidth('Số: ' + this.NKItem.Sophieu) * doc.internal.getFontSize() / doc.internal.scaleFactor;
		var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
		doc.text(textOffset, y, 'Số: ' + this.NKItem.Sophieu);
		doc.text(160, y, 'TK có:');
		y += 12;

		doc.text(x,y, '- Họ và tên người giao hàng: ');
		if(nccInfo != null && nccInfo != undefined){
			doc.text(x + 50,y, nccInfo.NguoiDaiDien);
		}
		y += 7;

		doc.text(x,y, '- Địa chỉ: ');
		if(nccInfo != null && nccInfo != undefined){
			doc.text(x + 15,y, nccInfo.DiaChi);
		}
		y += 7;

		doc.text(x,y, '- Mã số thuế: ');
		if(nccInfo != null && nccInfo != undefined){
			doc.text(x + 22,y, nccInfo.MST);
		}
		y += 7;

		doc.text(x,y, '- Diễn giải: ' + this.NKItem.DienGiai); y += 7;
		doc.text(x,y, '- Theo');
		doc.text(x + 60,y, 'ngày');
		doc.text(x + 80,y, 'tháng');
		doc.text(x + 100,y, 'năm');
		doc.text(x + 120,y, 'của');y += 7;
		doc.text(x,y, '- Nhập tại kho: ' + this.tmpChiTietNK[0].TenKho);

		y +=10;
		(doc as any).autoTable({
			head: head,
			body: dataRow,
			styles: {
				font: 'Roboto-Regular',
      			fontStyle: 'normal',
				fontSize: 10,
			},
			headStyles:{
				font: 'Roboto-Regular',
				fontStyle: 'bold',
				fontSize: 11,
			},
			margin: { top: y, left: 10 },
			theme: 'grid'
		})
		y +=15 + ((dataRow.length + 1)*10);

		doc.text(x,y, '- Số tiền bằng chữ: ');
		doc.setFontType("italic");
		if(total > 0){
			doc.text(x + 30,y, FunctionPublic.convertCurrencyFromNumToStr(total.toString()));
		}
		y += 7;

		doc.text(x,y, '- Số chứng từ gốc kèm theo: ' + ghichu); y += 10;

		var toDay = new Date();
		var d = toDay.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' }).split("/");
		doc.text(x + 140, y, 'Ngày ' + d[1] + ' tháng ' + d[0] + ' năm ' + d[2]); y += 7;

		doc.setFontType("bold");
		doc.text(20, y, 'Người lập phiếu');
		doc.text(70, y, 'Người giao hàng');
		doc.text(120, y, 'Thủ kho');
		doc.text(160, y, 'Kế toán trưởng');y += 7;

		doc.setFontType("normal");
		doc.text(24, y, '(Ký, họ tên)');
		doc.text(74, y, '(Ký, họ tên)');
		doc.text(118, y, '(Ký, họ tên)');
		doc.text(163, y, '(Ký, họ tên)');;y += 40;

		doc.text(20, y, this.NKItem.TenNguoitao);

		// Download PDF document
		doc.save(this.NKItem.Sophieu + '_Report.pdf');
	}
	checkWarningState(item: ChiTietPhieuNhapKho){
		var tmp = Number(item.Soluongchungtu) * item.DungSai / 100;
		var result = -1;

		if(Number(item.Soluongthucnhap) > Number(item.Soluongchungtu) + tmp){
			result = 0;
		}
		if((Number(item.Soluongchungtu) - tmp) <= Number(item.Soluongthucnhap)
		&& (Number(item.Soluongthucnhap) <= Number(item.Soluongchungtu) + tmp)){
			result = 1;
		}
		if(Number(item.Soluongthucnhap) < Number(item.Soluongchungtu) - tmp){
			result = 2;
		}
		return result;
	}
	warningState(item: ChiTietPhieuNhapKho ){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return '> dung sai cho phép';
			case 1:
				return 'Thuộc dung sai cho phép';
			case 2:
				return '< dung sai cho phép';
			default:
				return ''
		}
	}
	cssWarningState(item:ChiTietPhieuNhapKho){
		let result = this.checkWarningState(item);
		switch(result){
			case 0:
				return 'red';
			case 1:
				return 'green';
			case 2:
				return 'orange';
			default:
				return ''
		}
	}
	sum_so_luong(){
		return this.tmpChiTietNK.length > 0 ? this.tmpChiTietNK.map(x => Number(x.KhoiLuongQuyDoi)).reduce((a, b) => a + b) : 0;
	}

	getDS_ViTriKho_Empty(IdKho: number, item: any){
		let listVTK_Empty = [];
		let listVTK_Full = [];
		let hKho = 1, hKhoMax = 0;
		let cKho = 1, cKhoMax = 0;
		let tKho = 1, tKhoMax = 0;
		this.nhapKhoService.getDSVTK(IdKho).subscribe(res => {
			if(res && res.status == 1){
				if(res.data != null){
					listVTK_Full = res.data.listVTK;
					hKhoMax = res.data.hKho;
					cKhoMax = res.data.cKho;
					tKhoMax = res.data.tKho;
					let listTTHangTon = res.data.listTTHangTon;
					for(let t = tKho; t <= tKhoMax; t++){
						for(let c = cKho; c <= cKhoMax; c++){
							for(let h = hKho; h <= hKhoMax; h++){
								let value = this.lpad(h,3)+"."+this.lpad(c,3)+"."+this.lpad(t,2);
								if(listVTK_Full.findIndex(x => x == value) == -1){
									let _item = listTTHangTon.find( x => value == x.VTK);
									if(_item != null && _item.TongKL > 0){
										if(!_item.isMax){
											listVTK_Empty.push(value + '|Đã có hàng - ' + this.f_number(_item.TongKL));
										} else{
											listVTK_Empty.push(value + '|Đã đầy hàng|' + _item.TongKL);
										}

									} else {
										listVTK_Empty.push(value)
									}
								}
							}
						}
					}
					let _index = this.tmpChiTietNK.findIndex(x => x === item)
					if(_index > -1){
						this.SaveListVTK[_index] = listVTK_Empty;
						this.arrayVTKhoForEachHH[_index].next(listVTK_Empty.slice());

						if(item.ViTriKho != null && item.ViTriKho != undefined && item.ViTriKho != ''){
							let _tmpIndex = this.SaveListVTK[_index].findIndex(x => x && (x.split('|')[0] == item.ViTriKho))
							if(_tmpIndex == -1){
								this.tmpChiTietNK[_index].ViTriKho = ''
							}else{
								this.tmpChiTietNK[_index].ViTriKho = this.SaveListVTK[_index][_tmpIndex];
							}
						}
					}
				}
			}
		});
	}
	filterListVTKho(item: any) {
		let _index = this.tmpChiTietNK.findIndex(x => x === item)
		if(_index > -1){
			if (!this.SaveListVTK[_index]) {
				return;
			}
			let search = this.VTKhoFilterCtrl;

			if (!search) {
				this.arrayVTKhoForEachHH[_index].next(this.SaveListVTK[_index].slice());
				return;
			} else {
				search = search.toLowerCase();
			}
			this.arrayVTKhoForEachHH[_index].next(this.SaveListVTK[_index].filter(ts =>
				ts.toLowerCase().indexOf(search) > -1)
			);
			this.changeDetectView();
		}
	}
	resetViTriKho(item:any){
		let _index = this.tmpChiTietNK.findIndex(x => x === item)
		if(_index > -1){
			this.tmpChiTietNK[_index].ViTriKho = "";
			this.changeDetectView();
		}
	}
	checkVTKCoHangDisable(vtk: string, item: ChiTietPhieuNhapKho){
		// if(!vtk)	return false;
		// let split = vtk.split('|');
		// if(split.length >= 2){
		// 	let numKho = 0;
		// 	if(split[1] == 'Đã đầy hàng'){
		// 		numKho = Number(split[2])
		// 	}else{
		// 		let formatN = split[1].split('-');
		// 		if(formatN.length >= 2){
		// 			let txt = formatN[1].trim().substring(0, formatN[1].length - 3).trim();
		// 			let format1 = this.f_number(txt);
		// 			numKho = Number(format1);
		// 		}
		// 	}
		// 	let sum = Number(item.Soluongthucnhap) + numKho
		// 	if(sum && sum > this.maxKLVTKDisable){
		// 		return true;
		// 	}
		// }
		return false;
	}
	checkVTKWhenChangeSL(vtk: string, item: ChiTietPhieuNhapKho){
		if(!vtk)	return false;
		let split = vtk.split('|');
		if(split.length >= 2){
			let numKho = 0;
			if(split[1] == 'Đã đầy hàng'){
				numKho = Number(split[2])
			}else{
				let formatN = split[1].split('-');
				if(formatN.length >= 2){
					let txt = formatN[1].trim().substring(0, formatN[1].length - 3).trim();
					let format1 = this.f_number(txt);
					numKho = Number(format1);
				}
			}
			let sum = Number(item.Soluongthucnhap) + numKho
			if(sum && sum > this.maxKLVTKDisable){
				item.ViTriKho = '';
			}
		}
		return true;
	}
	checkVTKCoHang(vtk: string, getFirst: boolean){
		if(!vtk)	return '';
		let split = vtk.split('|');
		if(split.length == 2){
			return getFirst ? split[0] : (split.length >= 1 ? split[1]: '');
		} else if (split.length == 3){
			return getFirst ? split[0] : (split[1] + ' - ' + this.f_number(split[2]));
		}
		return getFirst ? split[0] : (split.length >= 1 ? split[1]: '');
	}
	delete(item: ChiTietPhieuNhapKho) {
		const _deleteMessage = `Chi tiết phiếu nhập kho đã được hủy`;
		const dialogRef = this.layoutUtilsService.POP01(this.NKItem.Sophieu);
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.nhapKhoService.cancel_detail(item.IdCtnk).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
					this.nhapKhoService.getItemById(this.id).subscribe(res => {
						if(res.status == 1){
							this.NKItem = res.data
							if(this.NKForm != null){
								this.bindingValueAfterCallAPIDetail();
							}
						}
					});
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
			});
		});
	}
	/*------------------------------------------------------------- */


	/*------------------------------ Extend Options --------------------------*/
	timKiemNangCao(){
		this.openTimKiemNangCao = true;

		const dialogRef = this.dialog.open(TimKiemNangCaoListComponent, {
			data: {
				kw : this.focusDetail.first.nativeElement.value
			},
			maxHeight: '90vh',
			width: '90vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			this.openTimKiemNangCao = false;
			if (res == undefined || res == null) {
				return;
			}
			else{
				if (!res.isChange) {
					return;
				}
				if(res.dataAdd.length != 0){
					this.afterSelectHH(res.dataAdd.toString())
				}
			}
		});
	}
	tabChange(event: MatTabChangeEvent){
		if(event.index == 0)
			this.flagTab = 0;
		else if(event.index == 1)
			this.flagTab = 1;
		this.changeDetectView();
    }
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	scrollToBottom(){
		setTimeout(() => {
			// let height = document.getElementById('dialog-form').scrollHeight
			// document.getElementById('dialog-form').scrollTo({ top: height, behavior: 'smooth' });
			window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth' });
		}, 300);
	}
	highlightNewestRecord(currentPosition: number) {
		if (this.saveAddedCT.findIndex(x => x == currentPosition) > -1) {
			return true;
		}
		return false;
	}
	isDisableButton(){
		if( this.HHForm.invalid ||
			this.HHForm.controls["TenHang"].value == null ||
			this.HHForm.controls["TenHang"].value == ''){
				this.disableNewButton = true;
		}
		else{
			this.disableNewButton = false;
		}
	}
	openNhapKho(){
		const dialogRef = this.dialog.open(KhoNhapPageFileComponent, {
			data: {
				Id: this.NKItem.IdNk
			},
			maxHeight: '90vh',
			width: '70vw'
		});
		dialogRef.afterClosed().subscribe(res => {
			if (res == undefined || res == null) {
				return;
			}
			else{

			}
		});
	}
	exportExcelDetail(): void {
	
		this.nhapKhoService.downloadExcelDetail(this.NKItem.IdNk).subscribe(blob => {
			const currentDate = new Date();
			const formattedDate = currentDate.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' }).replace(/\//g, '-');
			const formattedTime = currentDate.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' }).replace(/:/g, '');
			const fileName = `PhieuNhapKho_${this.NKItem.IdNk}.xlsx`;
			var downloadLink = document.createElement("a");
			var url = URL.createObjectURL(blob);
			downloadLink.href = url;
			downloadLink.download = fileName;
			document.body.appendChild(downloadLink);
			downloadLink.click();
			document.body.removeChild(downloadLink);
		});
	}
	getListNameKhoDetail(){
		if(this.tmpChiTietNK.length > 0){
			let uniqueIdKho = this.tmpChiTietNK.map((item) => item.IdKho).filter((value, index, self) => self.indexOf(value) === index);
			let listName = this.listKhoVer2.filter(x => uniqueIdKho.includes(x.Id_Kho)).map(x => x.MaKho + ' - ' + x.TenKho);
			return listName.join(' , ');
		}
		return '';
	}
	/* -----------------------------------------------------------------------*/
	// .. Tag kho ========================================================================
	// .. Danh sách tag kho
	ListTagKho() {
		this.dungChungService.listTagKho().subscribe(res => {
			this.loadingSubject.next(false);
			if (res && res.status === 1) {
				this.listTagFull = res.data;
				this.changeDetectView()
			};
		});
	}
	// .. Hàm lấy mã màu từ tên tag kho
	getBgColorTag(tag: string){
		var _item = this.listTagFull.find(_x => _x.tagkho == tag);
		return _item == null? '#ccc' : _item.BackgroundColor;
	}
	//================================================================================
	// ' Hàm format date sang định dạng text dd/MM/yyyy hh:mm '
	strDate(d){
		if (!d) return '';
		var date  = new Date(d);
		var day   = ("00" + date.getDate()).slice(-2);
  		var month = ("00" + (date.getMonth() + 1)).slice(-2);
  		var year  = date.getFullYear();
		var hours = ("00" + date.getHours()).slice(-2);
		var minutes = ("00" + date.getMinutes()).slice(-2);
		return day + "/" + month + "/" + year + " " + hours + ":" + minutes;
	}
	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case true:
				return this.CONFIG.COLOR_STATE._HuyCase;
			case false:
				return this.CONFIG.COLOR_STATE._HoanTatCase;
		}
	}
	// print() {
	// 	const content = document.getElementById('print-section');

	// 	html2canvas(content).then(canvas => {
	// 	  const imgData = canvas.toDataURL('image/png');
	// 	  const pdf = new jsPDF();

	// 	  const imgProps = pdf.getImageProperties(imgData);
	// 	  const pdfWidth = pdf.internal.pageSize.getWidth();
	// 	  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

	// 	  pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
	// 	  pdf.save('ReportNK.pdf');
	// 	});
	// }
	getNumOfCanSelected(){
		var count = 0;
		this.tmpChiTietNK.forEach((x, index)=> {
			if(!x.IsDaLenHang){
				count++;
			}
		})
		return count;
	}
	isAllSelected() {
		const numSelected = this.selection.selected.length;
		const numRows = this.getNumOfCanSelected();
		return numSelected === numRows;
	}
	masterToggle() {
		;
		if (this.isAllSelected()) {
			this.selection.clear();
		} else {
			this.tmpChiTietNK.forEach((row, index) => {
				if(!row.IsDaLenHang){
					this.selection.select(row)
				}
			});
		}
	}
}
